
export const environment = {
   production: true,
   BASE_URL: "https://api.ap-southeast-2.invflow.com/",
   STRIPE_PUBLISHABLE_KEY: "pk_live_51MS6xRHmyU2mpCZlvxsBb9gOkqu7VuMD702LL1u3UYJqvUyJYOliyUVQtVl1GzVKAE6WElb1ahcOcd1Eay1P5nkZ00C3agqqX7",
   GOOGLE_MAPS_API_KEY: "AIzaSyCwAKaJfVL3EkEoRYhl2dq7WSmqhNHVh2M",
};
